<template>
  <v-container fluid class="grey lighten-2">
    <v-row>
      <v-col class="mt-2" cols="12">
        <v-dialog v-model="dialog" max-width="800" scrollable persistent transition="dialog-bottom-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on">
              <v-icon id="emergency_kit">{{ icon }}</v-icon>{{ phrase.title_emergency_kit }}
            </v-btn>
          </template>

          <v-card height=400>
            <v-card-title class="text-h5 grey lighten-2">{{ phrase.title_emergency_kit }}</v-card-title>
            <v-card-text style="white-space: pre-line">
              <div class="my-5 text--primary">{{ help_emergency_kit_text }}</div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-start">
              <v-btn color="primary" text @click="dialog = false">
                {{ phrase.dialog_close }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-select class="d-inline-flex align-center mt-2 ml-4" :items=this.$store.state.login_response.emergency_kit item-text="name" item-value="cost" return-object :label="this.$store.state.select.emergency_kit" @change="value_emergency_kit"></v-select>
        <span class="ml-4 font-weight-bold header-total-inline">合計 {{ (this.$store.state.breakdown.emergency_kit).toLocaleString() }}円</span>
      </v-col>
      <v-col>
        <v-row>
          <v-col class="mt-2 d-flex" cols="12" sm="6" md="3" lg="3" v-for="kit in this.$store.state.login_response.emergency_kit" :key="kit.key">
            <v-card class="d-flex flex-column flex-grow-1">
              <v-card-title>{{ kit.name }}</v-card-title>
              <v-col align="center">
                <v-img max-height="200" max-width="200" v-bind:src="require('@/assets/emergency_kit/'+kit.img+'.jpg')"></v-img>
              </v-col>
              <v-card-text>
                <v-simple-table>
                  <thead></thead>
                  <tbody>
                    <tr>
                      <td>内容</td>
                      <td>{{ kit.content }}</td>
                    </tr>
                    <tr>
                      <td>金額</td>
                      <td>{{ kit.cost.toLocaleString() }}円</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import words from '../assets/words.json'

export default({
  data: () => ({
    icon: 'mdi-bag-personal',
    dialog: false,
    phrase: {}
  }),
  mounted: function () {
    this.getWords()
  },
  computed: {
    help_emergency_kit_text () {
      return this.phrase.help_emergency_kit
    }
  },
  methods: {
    value_emergency_kit: function(value) {
      this.$store.commit('value_emergency_kit', value);
      this.$store.commit('rebalance');
      this.$store.commit('set_progress');
    },
    getWords: function () {
      this.phrase = words
    }
  }
})
</script>
